import { ADD_ROLE, BASE_URL, EDIt_ROLE, ROLE, ROLE_BASE, ROLE_DROP_DOWN } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IRoleInput } from "models/Roles";

export async function getRoles(params: string = "") {
  const response = await axios.get(BASE_URL + ROLE + params);
  return response.data;
}

export async function getRolesDropDown(params: string = "") {
  const response = await axios.get(BASE_URL + ROLE_DROP_DOWN + params);
  return response.data;
}
export async function addRole(data: IRoleInput) {
  const response = await axios.post(BASE_URL + ADD_ROLE+`?roleName=${data.name}` );
  return response.data;
}

export async function editRole(data: IRoleInput,id:string) {
  const response = await axios.post(BASE_URL + EDIt_ROLE+`?roleId=${id}&newRoleName=${data.name}` );
  return response.data;
}

export async function deleteRole(id:string) {
  const response = await axios.delete(BASE_URL + ROLE_BASE+`/${id}` );
  return response.data;
}



export const RolesCells: HeadCell[] = [
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
